export const categories = [
  { slug: 'japan-sakura', name: '日本樱花', icon: 'ri-japan-line', description: '日本各地绝美樱花名所实拍', count: 128 },
  { slug: 'china-sakura', name: '中国樱花', icon: 'ri-china-railway-line', description: '国内最美赏樱地合集', count: 96 },
  { slug: 'timelapse', name: '延时摄影', icon: 'ri-time-line', description: '樱花绽放绝美延时', count: 64 },
  { slug: 'travel-vlog', name: '旅行Vlog', icon: 'ri-road-map-line', description: '跟着镜头去赏樱', count: 83 },
  { slug: 'viewing-guide', name: '赏樱攻略', icon: 'ri-guide-line', description: '最佳时间与地点推荐', count: 47 },
];

export const videos = [
  {
    id: 'v001',
    title: '京都岚山樱花隧道 4K 漫游实录',
    cover: 'https://readdy.ai/api/search-image?query=Kyoto%20Arashiyama%20cherry%20blossom%20tunnel%20in%20full%20bloom%2C%20pink%20sakura%20petals%20falling%20gently%20along%20a%20winding%20stone%20path%2C%20soft%20spring%20sunlight%20filtering%20through%20branches%2C%20dreamy%20atmospheric%20scene%20with%20warm%20pastel%20tones%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20artistic%20photography%20style%20with%20gentle%20bokeh%20background&width=640&height=360&seq=sakura-video-001&orientation=landscape',
    duration: '12:36',
    category: '日本樱花',
    views: 283000,
    date: '2024-04-05',
    description: '跟随镜头漫步京都岚山最著名的樱花隧道，感受被粉色花海包围的春日浪漫。全程4K高清录制，收录清晨无人时刻的绝美画面。',
  },
  {
    id: 'v002',
    title: '武汉大学樱花大道 春日漫步',
    cover: 'https://readdy.ai/api/search-image?query=Wuhan%20University%20cherry%20blossom%20avenue%20with%20historic%20buildings%20in%20background%2C%20hundreds%20of%20sakura%20trees%20in%20full%20bloom%20lining%20both%20sides%20of%20a%20campus%20road%2C%20students%20walking%20under%20pink%20canopy%2C%20soft%20spring%20morning%20light%2C%20dreamy%20romantic%20atmosphere%2C%20editorial%20photography%20with%20warm%20pastel%20color%20palette&width=640&height=360&seq=sakura-video-002&orientation=landscape',
    duration: '08:52',
    category: '中国樱花',
    views: 356000,
    date: '2024-03-28',
    description: '三月的武大，樱花如云似霞。跟随我们一起走过这条中国最美的大学樱花大道，感受青春与花季的交织。',
  },
  {
    id: 'v003',
    title: '樱花七日 - 延时摄影纪录片',
    cover: 'https://readdy.ai/api/search-image?query=single%20cherry%20blossom%20branch%20against%20a%20minimalist%20soft%20cream%20background%2C%20delicate%20pink%20petals%20in%20various%20stages%20of%20blooming%2C%20from%20bud%20to%20full%20flower%2C%20time%20lapse%20aesthetic%2C%20clean%20and%20elegant%20composition%2C%20fine%20art%20botanical%20photography%20style%20with%20ethereal%20soft%20lighting&width=640&height=360&seq=sakura-video-003&orientation=landscape',
    duration: '05:18',
    category: '延时摄影',
    views: 412000,
    date: '2024-04-10',
    description: '从花苞到盛开再到凋零，记录一朵樱花短暂而灿烂的一生。日本谚语"樱花七日"，浓缩在这五分钟的延时摄影中。',
  },
  {
    id: 'v004',
    title: '东京赏樱一日游 Vlog',
    cover: 'https://readdy.ai/api/search-image?query=Tokyo%20Ueno%20Park%20cherry%20blossom%20festival%20scene%2C%20lanterns%20hanging%20under%20pink%20sakura%20trees%2C%20people%20having%20hanami%20picnic%20on%20blue%20tarps%2C%20warm%20afternoon%20sunlight%2C%20lively%20festival%20atmosphere%2C%20editorial%20travel%20photography%20with%20rich%20warm%20colors%20and%20natural%20light&width=640&height=360&seq=sakura-video-004&orientation=landscape',
    duration: '18:24',
    category: '旅行Vlog',
    views: 198000,
    date: '2024-04-02',
    description: '从清晨的目黑川到傍晚的上野公园，带你体验东京最地道的赏樱一日游。包含美食探店、打卡攻略和实用交通信息。',
  },
  {
    id: 'v005',
    title: '杭州西湖樱花季全景记录',
    cover: 'https://readdy.ai/api/search-image?query=Hangzhou%20West%20Lake%20cherry%20blossoms%20with%20traditional%20Chinese%20pavilion%20and%20willow%20trees%20reflecting%20on%20calm%20water%2C%20pink%20sakura%20petals%20floating%20on%20lake%20surface%2C%20misty%20spring%20morning%2C%20classical%20Chinese%20landscape%20painting%20aesthetic%2C%20soft%20ethereal%20atmosphere%20with%20muted%20pastel%20tones&width=640&height=360&seq=sakura-video-005&orientation=landscape',
    duration: '10:15',
    category: '中国樱花',
    views: 267000,
    date: '2024-03-25',
    description: '西湖边的樱花季，是江南春天最美的模样。白堤、苏堤、太子湾公园，我们走遍西湖周边所有赏樱名所。',
  },
  {
    id: 'v006',
    title: '奈良吉野山 三万株樱花盛开',
    cover: 'https://readdy.ai/api/search-image?query=Nara%20Yoshino%20mountain%20covered%20with%20thousands%20of%20cherry%20blossom%20trees%20cascading%20down%20mountain%20slopes%2C%20traditional%20wooden%20temple%20roof%20visible%20among%20pink%20blossoms%2C%20aerial%20perspective%2C%20dramatic%20layered%20composition%2C%20breathtaking%20natural%20landscape%20photography%20with%20soft%20spring%20haze&width=640&height=360&seq=sakura-video-006&orientation=landscape',
    duration: '15:42',
    category: '日本樱花',
    views: 523000,
    date: '2024-04-08',
    description: '吉野山被誉为日本第一赏樱名所，三万株樱花从山脚到山顶依次盛开，形成"一目千本"的震撼景观。',
  },
  {
    id: 'v007',
    title: '2024赏樱最佳时间全攻略',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20infographic%20style%20cherry%20blossom%20calendar%20map%20of%20Japan%20showing%20bloom%20forecast%20dates%2C%20soft%20pink%20gradient%20markers%20from%20south%20to%20north%2C%20clean%20minimal%20design%20with%20delicate%20sakura%20illustrations%2C%20editorial%20magazine%20style%2C%20warm%20cream%20background%20with%20muted%20coral%20accents&width=640&height=360&seq=sakura-video-007&orientation=landscape',
    duration: '09:30',
    category: '赏樱攻略',
    views: 189000,
    date: '2024-03-15',
    description: '根据日本气象协会最新樱花前线预测，为你整理2024年从南到北的最佳赏樱时间和地点。提前规划，不错过任何一场花见。',
  },
  {
    id: 'v008',
    title: '樱花雨慢镜头集锦',
    cover: 'https://readdy.ai/api/search-image?query=cherry%20blossom%20petals%20falling%20like%20pink%20snow%20in%20slow%20motion%20against%20a%20soft%20diffused%20background%2C%20golden%20hour%20warm%20light%20illuminating%20floating%20petals%2C%20dreamy%20ethereal%20atmosphere%2C%20artistic%20macro%20photography%20capturing%20the%20poetry%20of%20falling%20blossoms%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=sakura-video-008&orientation=landscape',
    duration: '04:55',
    category: '延时摄影',
    views: 347000,
    date: '2024-04-12',
    description: '用高速摄影机捕捉樱花飘落的每一个瞬间。当花瓣如雨般纷纷扬扬洒落，那是春天最深情的告别。',
  },
  {
    id: 'v009',
    title: '大阪造币局樱花通道漫步',
    cover: 'https://readdy.ai/api/search-image?query=Osaka%20Mint%20Bureau%20cherry%20blossom%20passage%20with%20rare%20double%20petal%20sakura%20varieties%20overhanging%20a%20stone%20path%2C%20visitors%20admiring%20blooms%20on%20a%20sunny%20spring%20day%2C%20lush%20pink%20blossoms%20in%20full%20bloom%2C%20warm%20golden%20afternoon%20light%2C%20travel%20photography%20style%20with%20vibrant%20yet%20soft%20color%20palette&width=640&height=360&seq=sakura-video-009&orientation=landscape',
    duration: '11:20',
    category: '日本樱花',
    views: 234000,
    date: '2024-04-07',
    description: '大阪造币局每年仅开放一周的樱花通道，汇集了130多种珍稀樱花品种。八重樱、御衣黄，你见过的没见过的樱花都在这里。',
  },
  {
    id: 'v010',
    title: '无锡鼋头渚樱花季全记录',
    cover: 'https://readdy.ai/api/search-image?query=Wuxi%20Yuantouzhu%20scenic%20area%20with%20Taihu%20Lake%20in%20background%2C%20cherry%20blossom%20trees%20in%20full%20bloom%20along%20the%20lake%20shore%2C%20traditional%20Chinese%20bridge%20and%20pagoda%2C%20misty%20spring%20morning%20with%20soft%20pink%20and%20teal%20color%20palette%2C%20classical%20Chinese%20garden%20aesthetic%20photography&width=640&height=360&seq=sakura-video-010&orientation=landscape',
    duration: '09:48',
    category: '中国樱花',
    views: 312000,
    date: '2024-03-30',
    description: '太湖佳绝处，毕竟在鼋头。三万株樱花环绕太湖之滨，花开时节如云似雪，是江南最美的赏樱胜地之一。',
  },
  {
    id: 'v011',
    title: '一个人的北海道赏樱之旅',
    cover: 'https://readdy.ai/api/search-image?query=Hokkaido%20Goryokaku%20Park%20star%20shaped%20fort%20surrounded%20by%20cherry%20blossoms%2C%20aerial%20view%20showing%20the%20unique%20star%20moat%20filled%20with%20pink%20sakura%2C%20late%20spring%20bloom%2C%20clear%20blue%20sky%2C%20dramatic%20landscape%20photography%20with%20striking%20geometric%20composition&width=640&height=360&seq=sakura-video-011&orientation=landscape',
    duration: '22:15',
    category: '旅行Vlog',
    views: 176000,
    date: '2024-05-02',
    description: '五月的北海道，樱花才刚刚绽放。一个人的慢旅行，从函馆五棱郭到小樽运河，寻找北国最晚的春天。',
  },
  {
    id: 'v012',
    title: '樱花季摄影技巧入门指南',
    cover: 'https://readdy.ai/api/search-image?query=professional%20camera%20on%20tripod%20pointing%20at%20cherry%20blossom%20branches%2C%20photographer%20silhouette%20in%20golden%20hour%20backlight%2C%20soft%20pink%20blossoms%20in%20foreground%20with%20lens%20flare%2C%20educational%20tutorial%20aesthetic%2C%20warm%20atmospheric%20lighting%2C%20creative%20photography%20composition&width=640&height=360&seq=sakura-video-012&orientation=landscape',
    duration: '07:40',
    category: '赏樱攻略',
    views: 145000,
    date: '2024-03-20',
    description: '从设备选择到构图技巧，从光线运用到的后期调色，手把手教你拍出令人惊艳的樱花大片。新手也能轻松上手。',
  },
];